import { displayConsoleBrand } from '@/lib/console-brand';
import { shouldIgnoreGlobalError } from '@/lib/error-filter';
import { devLog } from '@/lib/logger';

devLog('[prebootstrap] loaded');
if (import.meta.env.VITE_ENV_LABEL !== 'PRD') {
  displayConsoleBrand();
}

window.addEventListener("error", (event) => {
  if (shouldIgnoreGlobalError(event)) return;
  console.error("[prebootstrap:error]", event.error ?? event.message, {
    source: event.filename,
    line: event.lineno,
    column: event.colno,
  });
});

window.addEventListener("unhandledrejection", (event) => {
  console.error("[prebootstrap:rejection]", event.reason);
});
